import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchFilials } from "../../../action/handbook";
import Select from 'react-select';
import DatePicker, { registerLocale } from "react-datepicker";
import ru from "date-fns/locale/ru";
import moment from "moment";
import { fetchOrCreateWages } from "../../../action/cassa";
import ErrorContainer from "../../utils/ErrorContainer";
import { withRouter  } from 'react-router-dom';
import swal from 'sweetalert';

const ruNominative = {
    ...ru,
    localize: {
        ...ru.localize,
        month: (n) => {
            const months = [
                'январь', 'февраль', 'март', 'апрель', 'май', 'июнь',
                'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'
            ];
            return months[n];
        },
        monthAbbr: (n) => {
            const monthsAbbr = [
                'янв', 'фев', 'мар', 'апр', 'май', 'июн',
                'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'
            ];
            return monthsAbbr[n];
        }
    }
};

registerLocale("ruNominative", ruNominative);

function Wages({ history }){
    const points = useSelector(state => state.handbook.filials);
    const pointsCount = useSelector(state => state.handbook.count.filials);
    const loadingPoints = useSelector(state => state.loaders.filials);
    const loadingWages = useSelector(state => state.loaders.wages);
    const loading = loadingPoints || loadingWages;

    const [selectedDate, setSelectedDate] = useState(new Date());
    const [selectedPoint, setSelectedPoint] = useState(null);
    
    const dispatch = useDispatch();

     useEffect(() => {
        const getData = async () => {
            if (isEmpty(points) || points.length < pointsCount) await dispatch(fetchFilials(null, true));
        };
        getData();
    }, [dispatch, points, pointsCount]);

    const renderPointLabel = (point) => {
        if (!point) return '-';
        const cityName = point.city ? point.city.name : 'Город не указан';
        return `${cityName}, ${point.street || 'Улица не указана'} ${point.house || ''}`
    };

    const pointsOptions = points.map((point) => ({ label: renderPointLabel(point), value: point.id, city: point.city })).sort((a, b) => {
        if(a.label.toLowerCase() < b.label.toLowerCase()) return -1;
        if(a.label.toLowerCase() > b.label.toLowerCase()) return 1;
        return 0;
    });

    const onSearch = async () => {
        if (!selectedPoint || !selectedDate) return;
        const pointId = selectedPoint.value ? selectedPoint.value : null;
        if (!pointId) return;
        const startOfMonthDate = moment(selectedDate).startOf('month').format('YYYY-MM-DDTHH:mm:ss') + '.000Z';
        if (!startOfMonthDate) return;
        const result = await dispatch(fetchOrCreateWages({ pointId, startOfMonthDate, withStaff: true }));
        
        if (result.error) {
            return swal({
                title: "Данные не найдены",
                text: result.error.message || '',
                icon: "warning",
                button: "Ок",
            });
        }
        if (result && result.id) history.push(`/cassa/wages/${result.id}`);
    }

    return(
        <div className="modal d-flex" style={{ width: '95vw', height: '95vh', justifyContent: 'center', alignItems: 'center', zIndex: 1 }}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title"> Заработная плата </h5>
                    </div>
                    <div className="modal-body">
                        <ErrorContainer field="wages" style={{ margin: '0 20px 20px' }} hasCloseButton={true}/>
                        <div className="form-group" style={{ width: '250px' }}>
                            <label>Филиал</label>
                            <Select
                                isLoading={loading}
                                isDisabled={loading}
                                isSearchable
                                menuPortalTarget={document.body}
                                closeMenuOnSelect={true}
                                options={pointsOptions}
                                placeholder="Филиал"
                                noOptionsMessage={() => 'Нет филиалов'}
                                onChange={setSelectedPoint}
                                value={selectedPoint}
                            />
                        </div>
                        <div className="form-group">
                            <label>Месяц</label>
                            <div style={{ width: '250px' }}>
                            <DatePicker
                                portalId="root-portal"
                                selected={selectedDate}
                                onChange={(date) => setSelectedDate(date)}
                                showMonthYearPicker
                                dateFormat="MMMM yyyy"
                                locale="ruNominative"
                                className="form-control"
                                wrapperClassName="react-datepicker-wrapper w-100"
                                showTimeSelect={false}
                            />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer" style={{ justifyContent: 'center' }}>
                        <button onClick={onSearch} disabled={loading || !selectedDate || !selectedPoint} className="btn btn-primary" style={{ width: '50%' }}>
                            Далее
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withRouter(Wages);